import React, { useState } from "react";
import { StyledDatePicker } from "../FuiStyles";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";

export const DateTextFieldCommonComponent = ({
  tentativeServiceEndDate,
  selectedEnvironment,
  isServiceEndDateInvalid,
  minDate,
  maxDate,
  handleChange,
  label,
  idkey
}) => {
  /**
   * Date Field Component for Tentative Service End Date
   * @author Isabel Sprengers
   * @version 3.0
   * @see Used in component: AutomaticTicketResolver.js, DedicatedPlatform.js, ManagedPlatform.js, OnPremiseService,js, PlainInstance.js, etc
   */

  const [selectedDate, setSelectedDate] = useState(tentativeServiceEndDate);
  const textLabel = label === undefined ? "Tentative Service End Date" : label;
  const idname = idkey === undefined ? "TentativeServiceEndDate" : idkey;
  //const bakes = isServiceEndDateInvalid === undefined ? false : isServiceEndDateInvalid;
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <StyledDatePicker
        autoOk
        label={textLabel}
        id={idname}
        value={selectedEnvironment === "" ? null : selectedDate}
        disabled={selectedEnvironment === ""}
        maxDate={maxDate ? maxDate : undefined}
        minDate={minDate ? minDate : undefined}
        onChange={(e) => {
          setSelectedDate(e);
          return handleChange(
            moment(e).format("YYYY-MM-DD"),
            idname
          );
        }}
        helperText={isServiceEndDateInvalid && "Please enter a valid date."}
        error={
          isServiceEndDateInvalid ||
          (!selectedDate &&
            selectedEnvironment !== "" &&
            isServiceEndDateInvalid) ||
          (!tentativeServiceEndDate && selectedEnvironment !== "")
        }
        variant="inline"
        inputVariant="outlined"
        format="MM/dd/yyyy"
        disableCloseOnSelect={true}
        disablePast={true}
      />
    </MuiPickersUtilsProvider>
  );
};

export const DateTextFieldCommonComponentv2 = ({
  valueDate,
  minDate,
  maxDate,
  handleChange,
  label,
  idkey,
}) => {
  /**
   * Date Field Component for Tentative Service End Date
   * @author Isabel Sprengers
   * @version 3.0
   * @see Used in component: AutomaticTicketResolver.js, DedicatedPlatform.js, ManagedPlatform.js, OnPremiseService,js, PlainInstance.js, etc
   */

  const [selectedDate, setSelectedDate] = useState(valueDate);
  const textLabel = label === undefined ? "Contract Availability Date" : label;
  const bakes = valueDate ? true : false

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <StyledDatePicker
        autoOk
        label={textLabel}
        id={"ContractAvailabilityDate"}
        value={selectedDate}
        maxDate={maxDate ? maxDate : undefined}
        minDate={minDate ? minDate : undefined}
        onChange={(e) => {
          setSelectedDate(e);
          return handleChange(
            moment(e).format("YYYY-MM-DD"),
            "ContractAvailabilityDate"
          );
        }}
        helperText={bakes && "Please enter a valid date."}
        error={bakes}
        variant="inline"
        inputVariant="outlined"
        format="MM/dd/yyyy"
        disableCloseOnSelect={true}
        disablePast={true}
      />
    </MuiPickersUtilsProvider>
  );
};